export class BackgroundElements {
    constructor(elements) {
        // Handle jQuery object, NodeList, or array
        if (elements && elements.length !== undefined) {
            this.backgroundElements = Array.from(elements);
        }
        else if (Array.isArray(elements)) {
            this.backgroundElements = elements;
        }
        else {
            this.backgroundElements = [];
        }
    }
    disable() {
        this.backgroundElements.forEach((elem) => {
            this.disableFocusTemporarily(elem);
        });
    }
    enable() {
        this.backgroundElements.forEach((elem) => {
            this.enableOriginalTabindex(elem);
        });
    }
    disableFocusTemporarily(elem) {
        const tabindex = elem.getAttribute("tabindex");
        // For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
        if (tabindex !== null && tabindex !== undefined) {
            elem.setAttribute("data-original-tabindex", tabindex);
            //l('original tabindex stored');
        }
        else {
            elem.setAttribute("data-original-tabindex", "false");
            //l('elem has no tabindex');
        }
        elem.setAttribute("tabindex", "-1");
    }
    enableOriginalTabindex(elem) {
        const originalTabindex = elem.getAttribute("data-original-tabindex");
        if (originalTabindex && originalTabindex !== "false") {
            elem.setAttribute("tabindex", originalTabindex);
        }
        else {
            elem.removeAttribute("tabindex");
        }
    }
}
